<script lang="ts">
  import { Monitor, Moon, Sun } from '@lucide/svelte';
  import { fa } from '../shared/i18n/fa';
  import { theme } from '../shared/theme/theme.svelte';

  /**
   * One button that steps through the device's theme, light and dark (ADR-047). The icon shows the
   * current choice and the name says it as well as what a press changes it to.
   */
  let { class: className, iconClass = 'size-4' }: { class: string; iconClass?: string } = $props();
  const ICONS = { system: Monitor, light: Sun, dark: Moon };
  const Icon = $derived(ICONS[theme.mode]);
  const label = $derived(fa.theme.switch(fa.theme.modes[theme.mode], fa.theme.modes[theme.next]));
</script>

<button type="button" onclick={() => theme.set(theme.next)} class={className} aria-label={label} title={label}>
  <Icon class={iconClass} aria-hidden="true" />
</button>
